import React, { createContext, useContext, useMemo, ReactNode } from 'react';

interface RequestStageContextValue {
  requestStage?: string;
  requestId?: string;
}

const RequestStageContext = createContext<RequestStageContextValue | undefined>(undefined);

interface RequestStageProviderProps {
  requestStage?: string;
  requestId?: string;
  children: ReactNode;
}

export const RequestStageProvider: React.FC<RequestStageProviderProps> = ({ requestStage, requestId, children }) => {
  const value = useMemo(() => ({ requestStage, requestId }), [requestStage, requestId]);
  return (
    <RequestStageContext.Provider value={value}>
      {children}
    </RequestStageContext.Provider>
  );
};

export const useRequestStage = (): string | undefined => {
  const context = useContext(RequestStageContext);
  return context?.requestStage;
};

export const useRequestId = (): string | undefined => {
  const context = useContext(RequestStageContext);
  return context?.requestId;
};
